<p-multiSelect
  [appendTo]="appendTo"
  [ngClass]="{
    'm-multiselect m-checkbox': true,
    'is-draggable': isDraggable,
    'ng-invalid': !isValid,
  }"
  [filterPlaceHolder]="filterPlaceHolder"
  [maxSelectedLabels]="maxSelectedLabels"
  [(ngModel)]="value"
  (ngModelChange)="onModelChange($event)"
  [options]="options"
  (onPanelShow)="handlePanelShow()"
  [placeholder]="placeholder()"
  [selectedItemsLabel]="selectedItemsLabel"
  [style]="{ width: width, height: height }"
  [panelStyleClass]="panelStyleClass + ' m-multiselect-panel'"
  (onPanelHide)="onPanelHide.emit($event)"
  [disabled]="disabled">
  <!-- Custom Filter Icon Template -->
  <ng-template pTemplate="filtericon">
    <!-- Example using a Font Awesome icon -->
    <i
      class="material-symbols-outlined icon-regular text-blue-600"
      aria-hidden="true"
      >search</i
    >
  </ng-template>

  <!-- Show tooltip for dropdown items with labels longer than 27 characters -->
  <ng-template let-option pTemplate="item">
    @if (option?.label?.length >= LABEL_TRUNCATE_LIMIT) {
      <m-tooltip [content]="option?.label" position="right">
        <span>
          {{ option?.label | ellipsis: LABEL_TRUNCATE_LIMIT }}
        </span>
      </m-tooltip>
    } @else {
      <span>{{ option?.label }}</span>
    }
  </ng-template>
</p-multiSelect>
